import { getMeta } from '@/router/helpers';
import {debounce} from 'lodash-es';

export const mainHeaderMixins = {
	data: () => ({
		atTop: true
	}),
	computed: {
		headerHeight() {
			return (getMax = false) => {
				const atTop = (!this.hasDenseHeader && this.atTop) || getMax;

				return (
					/* Dekstop */

					this.$vuetify.breakpoint.xlOnly
						? atTop
							? 160
							: 80
						: /* Tablet  */

						this.$vuetify.breakpoint.mdOnly || this.$vuetify.breakpoint.lgOnly
						? atTop
							? 120
							: 80
						: /* Mobile  */

						atTop
						? 80
						: 60
				);
			};
		},

		hasDenseHeader() {
			return !!Object(getMeta(this.$route.name, 'header')).dense;
		},

		hasFullWidthHeader() {
			return !!Object(getMeta(this.$route.name, 'header')).fullWidth;
		}
	},
	methods: {
		onScroll() {
				setTimeout(()=>{
					this.atTop = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0) === 0;
				}, (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0) <= 15 ? 300 : 0)
		}
	},
	created() {
		window.addEventListener('scroll', this.onScroll);
	},
	mounted() {
		this.onScroll();
	}
};
